var _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _polyline7, _polyline8, _polyline9, _polyline10, _polyline11, _polyline12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsDownOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "0.15in",
    height: "0.94in",
    viewBox: "0 0 10.64 67.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "10.34 28.75 7.83 30.92 5.32 33.1 2.81 30.92 0.3 28.75",
    fill: "none",
    stroke: "#ff1c31",
    strokeMiterlimit: 10,
    strokeWidth: 0.92
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "10.34 34.43 7.83 36.6 5.32 38.78 2.81 36.6 0.3 34.43",
    fill: "none",
    stroke: "#ff1c31",
    strokeMiterlimit: 10,
    strokeWidth: 0.92
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "10.34 40.11 7.83 42.28 5.32 44.46 2.81 42.28 0.3 40.11",
    fill: "none",
    stroke: "#ff1c31",
    strokeMiterlimit: 10,
    strokeWidth: 0.92
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "10.34 45.79 7.83 47.97 5.32 50.14 2.81 47.97 0.3 45.79",
    fill: "none",
    stroke: "#ff1c31",
    strokeMiterlimit: 10,
    strokeWidth: 0.92
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "10.34 51.47 7.83 53.65 5.32 55.82 2.81 53.65 0.3 51.47",
    fill: "none",
    stroke: "#ff1c31",
    strokeMiterlimit: 10,
    strokeWidth: 0.92
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    points: "10.34 0.35 7.83 2.52 5.32 4.69 2.81 2.52 0.3 0.35",
    fill: "none",
    stroke: "#ff1c31",
    strokeMiterlimit: 10,
    strokeWidth: 0.92
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    points: "10.34 6.03 7.83 8.2 5.32 10.37 2.81 8.2 0.3 6.03",
    fill: "none",
    stroke: "#ff1c31",
    strokeMiterlimit: 10,
    strokeWidth: 0.92
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    points: "10.34 11.71 7.83 13.88 5.32 16.05 2.81 13.88 0.3 11.71",
    fill: "none",
    stroke: "#ff1c31",
    strokeMiterlimit: 10,
    strokeWidth: 0.92
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    points: "10.34 17.39 7.83 19.56 5.32 21.73 2.81 19.56 0.3 17.39",
    fill: "none",
    stroke: "#ff1c31",
    strokeMiterlimit: 10,
    strokeWidth: 0.92
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    points: "10.34 23.07 7.83 25.24 5.32 27.41 2.81 25.24 0.3 23.07",
    fill: "none",
    stroke: "#ff1c31",
    strokeMiterlimit: 10,
    strokeWidth: 0.92
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    points: "10.34 57.09 7.83 59.27 5.32 61.44 2.81 59.27 0.3 57.09",
    fill: "none",
    stroke: "#ff1c31",
    strokeMiterlimit: 10,
    strokeWidth: 0.92
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    points: "10.34 62.77 7.83 64.95 5.32 67.12 2.81 64.95 0.3 62.77",
    fill: "none",
    stroke: "#ff1c31",
    strokeMiterlimit: 10,
    strokeWidth: 0.92
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsDownOrange);
export default __webpack_public_path__ + "static/media/arrows_down_orange.4d2afa4c475d4d2f97a68473b23093ce.svg";
export { ForwardRef as ReactComponent };